import type { XmlInjection, ITextReplacement, IResolutionStarted } from "../global";
import htmx from "htmx.org";
import getConfig from "../config/app";
import { ResolveExecutor } from "../office/ResolveExecutor";
import { modificationHandler } from "./modifications";
import { dispatch } from "../utils/events";
import { pipeline } from "./updates";

const resolveExecutor = new ResolveExecutor({
  modificationHandler,
  pipeline,
  dispatch,
});

// Display the dialog with resolve options
document.addEventListener("resolve-error-requested", async () => {
  const config = getConfig().resolveError;
  await htmx.ajax(config.method, config.url, {
    target: "#modal",
    swap: "innerHTML",
  });
});


// This after the user selects the resolution strategy, we:
// (1) fire register some hooks for success/fail ui updates
// (2) fire the selected startegy as an event (like xml-injection or replace-text)
// (3) the hooks should be invoked we can use htmx to update the UI
document.addEventListener(
  "resolve-error-started",
  async (e: CustomEvent<IResolutionStarted>) => {
    const clean = () => {
      document.removeEventListener("resolve-error-failed", failed);
      document.removeEventListener("resolve-error-success", success);
    };
    const success = () => {
      htmx.ajax("get", e.detail.successUrl, {});
    };
    const failed = () => {
      htmx.ajax("get", e.detail.failedUrl, {});
    };

    document.addEventListener("resolve-error-failed", failed);
    document.addEventListener("resolve-error-success", success);
    document.addEventListener("resolve-error-completed", clean, { once: true });

    document.dispatchEvent(
      new CustomEvent(e.detail.name, { detail: e.detail.detail })
    );
  }
);


// Activate the resolveExecuter when office is ready
document.addEventListener("office-ready", (e: CustomEvent<boolean>) => {
  if (e.detail) {
    resolveExecutor.start();
  } else {
    resolveExecutor.stop();
  }
});


// when an xml injection is requested
document.addEventListener(
  "xml-injection",
  async (e: CustomEvent<XmlInjection>) => {
    dispatch("save-location");
    await resolveExecutor.injectXml(e.detail);
  }
);

// when a text replacement is requested
document.addEventListener(
  "replace-text",
  async (e: CustomEvent<ITextReplacement>) => {
    dispatch("save-location");
    await resolveExecutor.replaceText(e.detail);
  }
);
